import React, { useEffect, useState } from "react";
import cx from "../Portal.module.css";
import { Row, Col, NavLink, Button } from "react-bootstrap";
import { httpPortal } from "../../Apis/commonApis";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import { ShowSwal } from "../../utils/alertSwal";
import { useDispatch } from "react-redux";
import {
  setPortalRefreshToken,
  setPortalAccessTokenExpiry,
} from "../../redux-toolkit/reducer/portalRefreshToken_reducer";
export default function NewPassword() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const email = location.state?.email;

  const [error, setError] = useState("");
  const [startAauthProcess, setStartAauthProcess] = useState(null);

  useEffect(() => {
    let intervalID = setInterval(() => {
      if (startAauthProcess) {
        emailAuth();
      }
    }, 3000);
    return () => clearInterval(intervalID);
  }, [startAauthProcess]);

  const signin = async (postdata) => {
    var data = JSON.stringify({
      email: email,
      password: postdata?.password,
    });
    const res = await httpPortal("login", "post", data, "withoutToken");
    if (res?.message == "FandF 2FA enabled.") {
      history.push({
        pathname: `/portal/securityQuestion`,
        state: {
          security_questions: res?.data?.security_questions?.question,
          email: email,
        },
      });
    } else if (res.message?.includes("An authentication email has been sent")) {
      ShowSwal(true, res.message);
      setStartAauthProcess(res.userId);
    } else if (res.status === true) {
      if (res.data && res.token && res.caresite) {
        handleRefreshToken(res);
      }
    } else {
      swal("failed", res.message, "error").then((value) => {
        return;
      });
    }
  };

  const handleRefreshToken = (res) => {
    localStorage.setItem("fandfData", JSON.stringify(res.data));
    localStorage.setItem("fandfam_token", res.token);
    localStorage.setItem("careSite", JSON.stringify(res?.caresite));

    // Save refresh token to Redux store
    if (res.refreshToken) {
      dispatch(
        setPortalRefreshToken({
          refreshToken: res.refreshToken,
        })
      );
    }

    // Update access token expiry in Redux
    dispatch(
      setPortalAccessTokenExpiry({
        accessToken: res.token,
      })
    );

    swal("Success", res.message, "success").then((value) => {
      history.push(`/portal/portal-main`, { replace: true });
    });
  };

  const emailAuth = async () => {
    const endPoint = `authenticateCron?userId=${startAauthProcess}&authProcess=login`;
    const res = await httpPortal(endPoint, "get", null, "withoutToken");
    if (res.status) {
      setStartAauthProcess(null);
      if (res.data && res.token && res.caresite) {
        localStorage.setItem("fandfData", JSON.stringify(res.data));
        localStorage.setItem("fandfam_token", res.token);
        localStorage.setItem("careSite", res?.caresite);

        // Save refresh token to Redux store
        if (res.refreshToken) {
          dispatch(
            setPortalRefreshToken({
              refreshToken: res.refreshToken,
            })
          );
        }

        // Update access token expiry in Redux
        dispatch(
          setPortalAccessTokenExpiry({
            accessToken: res.token,
          })
        );

        swal("Success", res.message, "success").then((value) => {
          history.push(`/portal/portal-main`, { replace: false });
        });
      }
    }
  };

  return (
    <div className={`${cx.LoginStart}`}>
      <div className={`container`}>
        <Row>
          <Col lg={4} md={6} sm={12} className={`m-auto`}>
            <div className={`${cx.LoginBox}`}>
              <img src="/admin/images/Newfooter_Logo.svg" alt="" />
              <h3>Welcome,</h3>
              <p>Please enter your password. </p>
              <div className={`${cx.formInput}`}>
                <div className={`${cx.inputEmail}`}>
                  <label>Password</label>
                  <input
                    className={`form-control`}
                    type="Password"
                    placeholder="*******"
                    {...register("password", {
                      required: true,
                    })}
                  />
                </div>
                {errors?.password?.type === "required" && (
                  <p className="error_style">This field is required</p>
                )}
                <p className="error_style">{error}</p>
              </div>
              <div className={`${cx.continueButton}`}>
                <NavLink to="#" onClick={handleSubmit(signin)}>
                  Continue
                </NavLink>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}
